import React from 'react';
import { useTranslation } from 'react-i18next';

import { SimpleFormStep } from '@epi-pages/LoadBenefit/components/Topup/SimpleFormStep';
import { FormStepMode } from '@epi-models/pages/Transfer';
import { StepField } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupForm.styles';
import { BenefitSelect } from '@epi-forms/controls/BenefitSelect/BenefitSelect';
import {
  LoadBenefitPageType,
  LoadBenefitPageTypes
} from '@epi-constants/onboardingTypes';
import { IBenefits } from '@epi-models/containers/ManageBenefits';

interface BenefitSelectionProps {
  loadableBenefits: IBenefits[];
  onboardingPageType: LoadBenefitPageType;
}

export const BenefitSelection = ({
  loadableBenefits,
  onboardingPageType
}: BenefitSelectionProps) => {
  const { t } = useTranslation();

  return (
    <SimpleFormStep
      mode={FormStepMode.Outlined}
      stepNumber={1}
      stepTitle={t('containers.deposit_money.topup_tab.form.benefit.title')}
    >
      <StepField>
        <BenefitSelect
          options={loadableBenefits}
          disabled={onboardingPageType === LoadBenefitPageTypes.Lounari}
        />
      </StepField>
    </SimpleFormStep>
  );
};
